var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"videoHome",staticClass:"welcome-video",attrs:{"preload":"","played":"","autoplay":"","muted":"","loop":"","playsinline":"","poster":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.video,"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }